<template>
    <div>
      <h2>입학관리</h2>
      <p>
        일반적으로 학원에서의 입학절차는 다음과 같습니다.<br/>
        1) 입학상담 전화 예약 2) 입학 레벨테스트 실시 3) 입학상담 4) 수강등록<br/>
        입학관리에 대한 기록으로 부모님과의 소통을 원활하게 합니다.
      </p>
      
      <section>
        <div class="p-relative section_0" id="enter_screen">
            <div class="ft-b">1)    입학관리</div>
        
            <div class="p-relative section_1">
                -   입학관리 화면에는 입학상담 예약학생 목록과 예약 스케쥴 화면으로 구분합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_enter_schedule.jpg" /></div>
            </div>
            
        </div>

        <p></p>
        <div class="p-relative section_0" id="enter_list">
            <div class="ft-b">2)    입학상담 예약</div>
        
            <div class="p-relative section_1">
                -   예약된 모든 학생의 목록을 나열합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_enter_list.jpg" /></div>
            </div>
            <div class="p-relative section_1">
                -   입학상담을 추가하려면 목록의 하단에 있는 "예약추가"버튼을 클릭합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_enter_add_modal.jpg" /></div>
            </div>
            <div class="p-relative section_1">
                -   예약일과 예약메모를 기록후 저장합니다.
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="enter_complte">
            <div class="ft-b">3)    상담 절차 완료</div>
        
            <div class="p-relative section_1">
                -   예약된 학생이 방문하였다면, 레벨테스트 후 상담을 실시합니다.
            </div>
            <div class="p-relative section_1">
                -   레벨테스트의 기록은 학생목록의 수정버튼을 클릭하거나
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_enter_edit1.jpg" /></div>
            </div>
            <div class="p-relative section_2">
                스케쥴에서 학생을 클릭합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_enter_edit2.jpg" /></div>
            </div>

            <div class="p-relative section_1">
                -   모든 절차가 완료되었다면, 입학 상담 절차를 "완료" 상태로 변경합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_enter_complete.jpg" /></div>
            </div>

        </div>
        
      </section>

      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
import goto from "./goto.js";
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '입학관리', link: '#enter_screen' },
                { label: '입학상담 예약', link: '#enter_list' },
                { label: '상담 절차 완료', link: '#enter_complte' },
                
            ]
        }
    },
    computed :{
    },
    methods : {
        goTo(link) {
            goto.goto_link(link);
        }
    },
    beforeMount() {
        goto.clear();
    }
}
</script>


